export function getAgeFromDOB(formattedBirthDate: string, today: Date): number {
    const birthDate = new Date(formattedBirthDate);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age;
}

export function birthDateFormatValidation(value: string): string {
    return value
        .replace(/\D/g, '') // Remove non-numeric characters
        .slice(0, 8) // Limit to 8 digits
        .replace(/^(\d{2})(\d{0,2})?(\d{0,4})?$/, (_, day, month, year) => {
            if (day?.length === 2) {
                day = Math.max(1, Math.min(parseInt(day, 10), 31))
                    .toString()
                    .padStart(2, '0');
            }
            if (month?.length === 2) {
                month = Math.max(1, Math.min(parseInt(month, 10), 12))
                    .toString()
                    .padStart(2, '0');
            }

            let formatted = day || '';
            if (month) {
                formatted += '/' + month;
            }
            if (year) {
                formatted += '/' + year;
            }
            return formatted;
        });
}
